import { render, staticRenderFns } from "./UploadDocBox.vue?vue&type=template&id=5703dea6&scoped=true"
import script from "./UploadDocBox.vue?vue&type=script&lang=js"
export * from "./UploadDocBox.vue?vue&type=script&lang=js"
import style0 from "./UploadDocBox.vue?vue&type=style&index=0&id=5703dea6&prod&lang=scss&scoped=true"
import style1 from "./UploadDocBox.vue?vue&type=style&index=1&id=5703dea6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5703dea6",
  null
  
)

export default component.exports